/* Local dependencies */
import {
  GetServiceProviderServiceInput,
  ServiceProviderService,
  ServiceProviderServiceRequiredField,
} from '../../../utils/types';

export enum GetServiceProviderServiceActionTypes {
  GET_SERVICE_PROVIDER_SERVICE_REQUEST = 'GET_SERVICE_PROVIDER_SERVICE_REQUEST',
  GET_SERVICE_PROVIDER_SERVICE_SUCCESS = 'GET_SERVICE_PROVIDER_SERVICE_SUCCESS',
  GET_SERVICE_PROVIDER_SERVICE_ERROR = 'GET_SERVICE_PROVIDER_SERVICE_ERROR',
  RESET_GET_SERVICE_PROVIDER_SERVICE_STATE = 'RESET_GET_SERVICE_PROVIDER_SERVICE_STATE',
  RESET_GET_SERVICE_PROVIDER_SERVICE_ERROR = 'RESET_GET_SERVICE_PROVIDER_SERVICE_ERROR',

  SET_PAY24_REQUIRED_FIELDS = 'SET_PAY24_REQUIRED_FIELDS',
  RESET_SET_PAY24_REQUIRED_FIELDS = 'RESET_SET_PAY24_REQUIRED_FIELDS',
}

export interface GetServiceProviderServiceRequest extends GetServiceProviderServiceInput {
  type: GetServiceProviderServiceActionTypes.GET_SERVICE_PROVIDER_SERVICE_REQUEST;
}

export interface GetServiceProviderServiceSuccess {
  type: GetServiceProviderServiceActionTypes.GET_SERVICE_PROVIDER_SERVICE_SUCCESS;
  serviceProviderService: ServiceProviderService;
}

export interface GetServiceProviderServiceError {
  type: GetServiceProviderServiceActionTypes.GET_SERVICE_PROVIDER_SERVICE_ERROR;
  error: Error;
}

export interface ResetGetServiceProviderServiceError {
  type: GetServiceProviderServiceActionTypes.RESET_GET_SERVICE_PROVIDER_SERVICE_ERROR;
}
export interface ResetGetServiceProviderServiceState {
  type: GetServiceProviderServiceActionTypes.RESET_GET_SERVICE_PROVIDER_SERVICE_STATE;
}

export interface SetPay24RequiredFields {
  type: GetServiceProviderServiceActionTypes.SET_PAY24_REQUIRED_FIELDS;
  pay24ServiceRequiredFields: ServiceProviderServiceRequiredField[];
}

export interface ResetSetPay24RequiredFields {
  type: GetServiceProviderServiceActionTypes.RESET_SET_PAY24_REQUIRED_FIELDS;
}

export type GetServiceProviderServiceAction =
  | GetServiceProviderServiceRequest
  | GetServiceProviderServiceSuccess
  | GetServiceProviderServiceError
  | ResetGetServiceProviderServiceError
  | ResetGetServiceProviderServiceState
  | SetPay24RequiredFields
  | ResetSetPay24RequiredFields;

export function getServiceProviderServiceRequest({
  serviceId,
  serviceProviderId,
}: GetServiceProviderServiceInput): GetServiceProviderServiceRequest {
  return {
    type: GetServiceProviderServiceActionTypes.GET_SERVICE_PROVIDER_SERVICE_REQUEST,
    serviceId,
    serviceProviderId,
  };
}

export function getServiceProviderServiceSuccess({
  serviceId,
  requiredFields,
}: ServiceProviderService): GetServiceProviderServiceSuccess {
  return {
    type: GetServiceProviderServiceActionTypes.GET_SERVICE_PROVIDER_SERVICE_SUCCESS,
    serviceProviderService: { serviceId, requiredFields },
  };
}

export function getServiceProviderServiceFailed(error: Error): GetServiceProviderServiceError {
  return {
    type: GetServiceProviderServiceActionTypes.GET_SERVICE_PROVIDER_SERVICE_ERROR,
    error: error,
  };
}

export function resetRetServiceProviderServiceState(): ResetGetServiceProviderServiceState {
  return {
    type: GetServiceProviderServiceActionTypes.RESET_GET_SERVICE_PROVIDER_SERVICE_STATE,
  };
}

export function resetRetServiceProviderServiceError(): ResetGetServiceProviderServiceError {
  return {
    type: GetServiceProviderServiceActionTypes.RESET_GET_SERVICE_PROVIDER_SERVICE_ERROR,
  };
}

export function setPay24RequiredFields(
  pay24ServiceRequiredFields: ServiceProviderServiceRequiredField[],
): SetPay24RequiredFields {
  return {
    type: GetServiceProviderServiceActionTypes.SET_PAY24_REQUIRED_FIELDS,
    pay24ServiceRequiredFields,
  };
}

export function resetSetPay24RequiredFields(): ResetSetPay24RequiredFields {
  return {
    type: GetServiceProviderServiceActionTypes.RESET_SET_PAY24_REQUIRED_FIELDS,
  };
}
